import { type Enum } from '@webapp/infrastructure/types/Enum'

export const UserTiers = {
  PRO: 'PRO',
  BASIC: 'BASIC',
} as const

export type UserTierEnum = Enum<typeof UserTiers>
